import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class CoursAdulte extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="contact-content">
                        <h1><span>Cours pour adultes - PRINTEMPS 2020</span></h1>   
                          <p><strong>Date du début: </strong>19 septembre<br />
                          <strong>Prè-inscriptions en ligne: </strong>8 septembre<br />
                          <strong>Inscription pour tous: </strong>10 septembre<br /></p>

                        <h2>Aquaforme</h2>
                        <p><strong>Lundi: </strong>15h45<br />
                        <strong>Jeudi: </strong>15h45<br /></p>

                        <h2>Aquajogging</h2>
                        <p><strong>Lundi: </strong>19h00<br /></p>

                        <h2>Adulte débutant</h2>
                        <p><strong>Lundi: </strong>20h00<br /></p>

                        <h2>Adulte intermédiaire</h2>
                        <p><strong>Lundi: </strong>21h00<br /></p>

                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default CoursAdulte
